
import React from 'react';

const ExternalDataIcon = () => (
    <svg width="20px" height="20px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="20" rx="2" fill="gray"/>
        <circle cx="10" cy="10" r="8" fill="white"/>
    </svg>
);

export default ExternalDataIcon;
